module.exports = __webpack_public_path__ + "static/media/review-logos.f55ff75c.png";